import React from 'react';
import PropTypes from 'prop-types';
import Column from './Columns/Column';
import rules from '../../../constants/businessRules/businessRules';
import * as Styled from './styles';
import { contentType } from '../../../types';
import imageSources from '../../../constants/imageSources/imageSources';

const CanvasBlockContent = ({ data, blockIndex, bodyBackgroundColor, sbBlockLoading }) => {
    const {
        paddingTop,
        paddingBottom,
        columnNum,
        columns,
        wrapperBackgroundColor,
        backgroundColor,
        structureLocked,
    } = data;
    const colSizesAreEqual = columns
        .reduce((acc, curr) => {
            acc.push(curr.length);
            return acc;
        }, [])
        .every((val, _, arr) => val === arr[0]);

    return (
        <div>
            <Styled.CanvasBlockWrapper
                wrapperBackgroundColor={wrapperBackgroundColor}
                bodyBackgroundColor={bodyBackgroundColor}
            >
                <Styled.BlockContentDiv
                    width={rules.BLOCK_WIDTH}
                    paddingTop={paddingTop}
                    paddingBottom={paddingBottom}
                    backgroundColor={backgroundColor}
                >
                    {sbBlockLoading === blockIndex ? (
                        <>
                            <Styled.LoaderWrapper width={150}>
                                <img src={imageSources.CONTENT_LIBRARY_LOADER} alt="loading" height="50" />
                            </Styled.LoaderWrapper>
                            <Styled.LoaderWrapper>
                                <img src={imageSources.CONTENT_LIBRARY_LOADER} alt="loading" height="50" />
                            </Styled.LoaderWrapper>
                        </>
                    ) : (
                        columns.map((column, index) => {
                            const isLastItem = index === columns.length - 1;
                            const prevColumnIdx = index - 1;
                            const nextColumnIdx = isLastItem ? -1 : index + 1;
                            const { size } = column;
                            const columnWidth = rules.BLOCK_WIDTH * parseFloat(size);
                            const canSplitColumn =
                                columnNum < rules.MAXIMUM_ALLOWABLE_BLOCK_COLUMN_NUMBERS &&
                                size / 2 >= rules.MINIMUM_ALLOWABLE_COLUMN_SIZE;

                            return (
                                <Styled.ColumnWrapper key={column.columnIdx}>
                                    <Column
                                        blockIndex={blockIndex}
                                        canSplitColumn={canSplitColumn}
                                        canJustifyColumns={!colSizesAreEqual}
                                        columnWidth={columnWidth}
                                        structureLocked={structureLocked}
                                        column={column}
                                        prevColumnIdx={prevColumnIdx}
                                        nextColumnIdx={nextColumnIdx}
                                    />
                                </Styled.ColumnWrapper>
                            );
                        })
                    )}
                </Styled.BlockContentDiv>
            </Styled.CanvasBlockWrapper>
        </div>
    );
};

CanvasBlockContent.propTypes = {
    data: contentType.isRequired,
    blockIndex: PropTypes.string.isRequired,
    bodyBackgroundColor: PropTypes.string,
    sbBlockLoading: PropTypes.string.isRequired,
};

CanvasBlockContent.defaultProps = {
    bodyBackgroundColor: '#FFFFFF',
};

export default CanvasBlockContent;
